import { render, staticRenderFns } from "./bookable-educator-card.vue?vue&type=template&id=0e0eb146&"
import script from "./bookable-educator-card.vue?vue&type=script&lang=js&"
export * from "./bookable-educator-card.vue?vue&type=script&lang=js&"
import style0 from "@/styles/candidate/candidate-card.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLazy } from 'vuetify/lib/components/VLazy';
installComponents(component, {VBtn,VCard,VIcon,VLazy})
